module.exports = __webpack_public_path__ + "img/bg_title_advantage.9cc7401e.png";